import { routing } from "./routing.js";

/**
 * Normalize a raw locale string into a supported lowercase locale code.
 *
 * Used at every cookie/header read site so that uppercase or mixed-case
 * inputs (manual cookies, intermediary proxies, legacy clients) do not
 * silent-miss into defaultLocale. Returns null when the value is not a
 * string or is not in `locales`.
 *
 * @param {unknown} locale
 * @param {string[]} [locales=routing.locales]
 * @returns {string|null}
 */
export function normalizeLocale(locale, locales = routing.locales) {
  if (typeof locale !== "string") return null;
  const normalized = locale.toLowerCase();
  return locales.includes(normalized) ? normalized : null;
}
